export const STAGE_COLORS = [
  "#64748b",
  "#2563eb",
  "#d97706",
  "#16a34a",
  "#7c3aed",
  "#db2777",
];

export const colorForStage = (stage) =>
  STAGE_COLORS[(stage?.order ?? 0) % STAGE_COLORS.length];
